(function() {
    angular
        .module("app")
        .factory("wzService", wzService)

    wzService.$inject = [
        "$rootScope",
        "$http"
    ]

    function wzService(
        $rootScope,
        $http
    ) {

        const service = {}

        service.listAll = (customerID) => {

            const _success = (response) => {
                return response.data
            }

            const _failure = (response) => {
                console.error(response)
            }

            return $http({
                method: "GET",
                url:    $rootScope.config.apiUrl + "/wzs?customer_id=" + String(customerID)
            }).then(_success, _failure)
        }

        service.createWZ = (customerID, config, success, failure) => {

            const _success = (response) => {
                if (success) {
                    success(response.data)
                }
            }

            const _failure = (response) => {
                console.error(response)
                if (failure) {
                    const error = response.data.hasOwnProperty("error") ? response.data.error : response.data
                    failure(error)

                }
            }

            return $http({
                method: "POST",
                url:    $rootScope.config.apiUrl + "/wzs",
                data: {
                    ...config,
                    customer_id: customerID
                }
            }).then(_success, _failure)
        }

        service.show = (wzID, success, failure) => {

            const _success = (response) => {
                if (success) {
                    success(response.data)
                }
            }

            const _failure = (response) => {
                console.error(response)
                if (failure) {
                    const error = response.data.hasOwnProperty("error") ? response.data.error : response.data
                    failure(error)

                }
            }

            return $http({
                method: "GET",
                url:    $rootScope.config.apiUrl + "/wzs/" + String(wzID)
            }).then(_success, _failure)
        }

        service.update = (wzData, success, failure) => {

            const _success = (response) => {
                if (success) {
                    success(response.data)
                }
            }

            const _failure = (response) => {
                console.error(response)
                if (failure) {
                    const error = response.data.hasOwnProperty("error") ? response.data.error : response.data
                    failure(error)

                }
            }

            return $http({
                method: "PUT",
                url:    $rootScope.config.apiUrl + "/wzs/" + wzData.id,
                data:   wzData
            }).then(_success, _failure)
        }

        service.adjustDisplayPositions = (wzID, newDisplayPositions, success, failure) => {

            const _success = (response) => {
                if (success) {
                    success(response.data)
                }
            }

            const _failure = (response) => {
                console.error(response)
                if (failure) {
                    const error = response.data.hasOwnProperty("error") ? response.data.error : response.data
                    failure(error)

                }
            }

            return $http({
                method: "PUT",
                url:    $rootScope.config.apiUrl + "/wzs/" + wzID + "/display_positions",
                data: {
                    new_display_positions: newDisplayPositions
                }
            }).then(_success, _failure)
        }

        service.addDevice = (wzID, deviceID, success, failure) => {

            const _success = (response) => {
                gtag("event", "workzone_add_device", { wz_id: wzID, device_id: deviceID })

                if (success) {
                    success(response.data)
                }
            }

            const _failure = (response) => {
                console.error(response)
                if (failure) {
                    const error = response.data.hasOwnProperty("error") ? response.data.error : response.data
                    failure(error)

                }
            }

            return $http({
                method: "PUT",
                url:    $rootScope.config.apiUrl + "/wzs/" + wzID + "/add_device",
                data: {
                    device_id: deviceID
                }
            }).then(_success, _failure)
        }

        service.removeDevice = (wzID, deviceID, success, failure) => {

            const _success = (response) => {
                gtag("event", "workzone_remove_device", { wz_id: wzID, device_id: deviceID })

                if (success) {
                    success(response.data)
                }
            }

            const _failure = (response) => {
                console.error(response)
                if (failure) {
                    const error = response.data.hasOwnProperty("error") ? response.data.error : response.data
                    failure(error)
                }
            }

            return $http({
                method: "PUT",
                url:    $rootScope.config.apiUrl + "/wzs/" + wzID + "/remove_device",
                data: {
                    device_id: deviceID
                }
            }).then(_success, _failure)

        }

        service.changeDisplayOrder = (wzID, orderedDeviceIDs, success, failure) => {

            const _success = (response) => {
                if (success) {
                    success(response.data)
                }
            }

            const _failure = (response) => {
                console.error(response)
                if (failure) {
                    const error = response.data.hasOwnProperty("error") ? response.data.error : response.data
                    failure(error)
                }
            }

            return $http({
                method: "PUT",
                url:    $rootScope.config.apiUrl + "/wzs/" + wzID + "/display_order",
                data: {
                    ordered_device_ids: orderedDeviceIDs
                }
            }).then(_success, _failure)

        }

        service.changePosition = (wzID, deviceID, newPosition, success, failure) => {

            const _success = (response) => {
                if (success) {
                    success(response.data)
                }
            }

            const _failure = (response) => {
                console.error(response)
                if (failure) {
                    const error = response.data.hasOwnProperty("error") ? response.data.error : response.data
                    failure(error)
                }
            }

            return $http({
                method: "PUT",
                url:    $rootScope.config.apiUrl + "/wzs/" + wzID + "/change_position",
                data: {
                    device_id:    deviceID,
                    new_position: newPosition
                }
            }).then(_success, _failure)

        }

        service.toggleOutput = (wzID, wzDeviceID, enableAsOutput, success, failure) => {

            const _success = (response) => {
                if (success) {
                    success(response.data)
                }
            }

            const _failure = (response) => {
                console.error(response)
                if (failure) {
                    const error = response.data.hasOwnProperty("error") ? response.data.error : response.data
                    failure(error)
                }
            }

            return $http({
                method: "PUT",
                url:    $rootScope.config.apiUrl + "/wzs/" + wzID + "/wz_device/" + wzDeviceID + "/set_qws_output",
                data: {
                    enabled: enableAsOutput
                }
            }).then(_success, _failure)

        }

        service.listActions = (wzID, startDate, endDate, page, perPage, success, failure) => {

            const _success = (response) => {
                if (success) {
                    success(response.data, response.headers("Total"))
                }
            }

            const _failure = (response) => {
                console.error(response)
                if (failure) {
                    const error = response.data.hasOwnProperty("error") ? response.data.error : response.data
                    failure(error)
                }
            }

            return $http({
                method: "GET",
                url:    $rootScope.config.apiUrl + "/wzs/" + wzID + "/actions?"
                + "start_date=" + startDate
                + "&end_date=" + endDate
                + "&sort=updated_at"
                + "&sort_direction=DESC"
                + "&page=" + page
                + "&perpage=" + perPage

            }).then(_success, _failure)

        }

        service.exportActions = (wzID, endDate, success, failure) => {

            const _success = (response) => {
                try {

                    if (response.data && response.data.size < 10) {
                        _failure({ data: { error: "No Actions available for the selected date range." }})
                        return
                    }

                    const url        = window.URL.createObjectURL(response.data)
                    const a          = document.createElement("a")
                    const header     = unescape(response.headers()["content-disposition"])
                    const startIndex = header.indexOf("filename=")

                    let filename = header.slice(startIndex + 9)

                    if (!filename || filename === "" || filename === "d" || filename === "d.zip") {
                        filename = "WZActions-Export.zip"
                    }

                    a.style    = "display: none"
                    a.href     = url
                    a.download = filename

                    document.body.appendChild(a)
                    a.click()

                    document.body.removeChild(a)
                    window.URL.revokeObjectURL(url)

                    if (success) {
                        success()
                    }

                } catch(error) {
                  _failure({ data: { error: error }})
                }
            }

            const _failure = (response) => {
                console.error(response)
                if (failure && response && response.data) {
                    const error = response.data.hasOwnProperty("error") ? response.data.error : response.data
                    failure(error)
                }
            }

            return $http({
                method:       "GET",
                url:          $rootScope.config.apiUrl + "/wzs/" + wzID + "/actions/export?end_date=" + endDate,
                responseType: "blob"
            }).then(_success, _failure)
        }

        service.delete = (wzID, success, failure) => {

            const _success = (response) => {
                if (success) {
                    success(response.data)
                }
            }

            const _failure = (response) => {
                console.error(response)
                if (failure) {
                    const error = response.data.hasOwnProperty("error") ? response.data.error : response.data
                    failure(error)

                }
            }

            return $http({
                method: "DELETE",
                url:    $rootScope.config.apiUrl + "/wzs/" + wzID
            }).then(_success, _failure)

        }

        service.getOutputConfiguration = (wzID, deviceID, success, failure) => {

            const _success = (response) => {
                if (success) {
                    success(response.data)
                }
            }

            const _failure = (response) => {
                console.error(response)
                if (failure) {
                    const error = response.data.hasOwnProperty("error") ? response.data.error : response.data
                    failure(error)

                }
            }

            return $http({
                method: "GET",
                url:    $rootScope.config.apiUrl + "/wzs/" + wzID + "/qws-output-configuration/" + String(deviceID),
            }).then(_success, _failure)
        }

        service.setOutputConfiguration = (wzID, deviceID, config, success, failure) => {

            const _success = (response) => {
                if (success) {
                    success(response.data)
                }
            }

            const _failure = (response) => {
                console.error(response)
                if (failure) {
                    const error = response.data.hasOwnProperty("error") ? response.data.error : response.data
                    failure(error)

                }
            }

            return $http({
                method: "PUT",
                url:    $rootScope.config.apiUrl + "/wzs/" + wzID + "/qws-output-configuration/" + String(deviceID),
                data: {
                    config: config
                }

            }).then(_success, _failure)
        }

        service.changeCustomer = (wzID, newCustomerID, success, failure) => {

            const _success = (response) => {
                if (success) {
                    success(response.data)
                }
            }

            const _failure = (response) => {
                console.error(response)
                if (failure) {
                    const error = response.data.hasOwnProperty("error") ? response.data.error : response.data
                    failure(error)

                }
            }

            return $http({
                method: "PUT",
                url:    $rootScope.config.apiUrl + "/wzs/" + wzID + "/customer",
                data: {
                    new_customer_id: newCustomerID
                }

            }).then(_success, _failure)
        }

        service.changeTitle = (wzID, newTitle, success, failure) => {

            const _success = (response) => {
                if (success) {
                    success(response.data)
                }
            }

            const _failure = (response) => {
                console.error(response)
                if (failure) {
                    const error = response.data.hasOwnProperty("error") ? response.data.error : response.data
                    failure(error)

                }
            }

            return $http({
                method: "PUT",
                url:    $rootScope.config.apiUrl + "/wzs/" + wzID + "/title",
                data: {
                    new_title: newTitle
                }

            }).then(_success, _failure)
        }

        service.toggleEnabled = (wzID, newEnabled, success, failure) => {

            const _success = (response) => {
                if (success) {
                    success(response.data)
                }
            }

            const _failure = (response) => {
                console.error(response)
                if (failure) {
                    const error = response.data.hasOwnProperty("error") ? response.data.error : response.data
                    failure(error)

                }
            }

            return $http({
                method: "PUT",
                url:    $rootScope.config.apiUrl + "/wzs/" + wzID + "/enabled",
                data: {
                    new_enabled: newEnabled
                }

            }).then(_success, _failure)
        }

        service.toggleDeviceEnabled = (wzID, wzDeviceID, newEnabled, success, failure) => {

            const _success = (response) => {
                if (success) {
                    success(response.data)
                }
            }

            const _failure = (response) => {
                console.error(response)
                if (failure) {
                    const error = response.data.hasOwnProperty("error") ? response.data.error : response.data
                    failure(error)

                }
            }

            return $http({
                method: "PUT",
                url:    $rootScope.config.apiUrl + "/wzs/" + wzID + "/wz_device/" + String(wzDeviceID) + "/enabled",
                data: {
                    new_enabled:  newEnabled
                }

            }).then(_success, _failure)
        }

        service.toggleAsQWSOutput = (wzID, wzDeviceID, shouldBe, success, failure) => {

            const _success = (response) => {
                if (success) {
                    success(response.data)
                }
            }

            const _failure = (response) => {
                console.error(response)
                if (failure) {
                    const error = response.data.hasOwnProperty("error") ? response.data.error : response.data
                    failure(error)

                }
            }

            return $http({
                method: "PUT",
                url:    $rootScope.config.apiUrl + "/wzs/" + wzID + "/wz_device/" + wzDeviceID + "/set_qws_output",
                data: {
                    should_be_output: shouldBe
                }

            }).then(_success, _failure)
        }

        service.toggleAsQWSInput = (wzID, wzDeviceID, shouldBe, success, failure) => {

            const _success = (response) => {
                if (success) {
                    success(response.data)
                }
            }

            const _failure = (response) => {
                console.error(response)
                if (failure) {
                    const error = response.data.hasOwnProperty("error") ? response.data.error : response.data
                    failure(error)

                }
            }

            return $http({
                method: "PUT",
                url:    $rootScope.config.apiUrl + "/wzs/" + wzID + "/wz_device/" + wzDeviceID + "/set_qws_input",
                data: {
                    should_be_input: shouldBe
                }

            }).then(_success, _failure)
        }

        return service

    }
})()
